export default {
  th: {
    messages: {
      required: 'จำเป็นต้องกรอก',
      email: 'โปรดใส่อีเมลที่ถูกต้อง',
      validFullName: 'โปรดตรวจสอบให้แน่ใจว่าคุณได้ป้อนชื่อและนามสกุล'
    },
    custom: {
      email: {
        required: 'โปรดใส่อีเมล'
      },
      fullName: {
        required: 'กรุณาใส่ชื่อเต็มที่ถูกต้อง',
        validateFullName: 'โปรดตรวจสอบให้แน่ใจว่าคุณได้ป้อนชื่อและนามสกุล'
      },
      firstName: {
        required: function () {
          return vueSupport?.featureFlags?.enableSignupRevamp ? 'ต้องระบุชื่อจริง' : 'โปรดใส่ชื่อจริง'
        }
      },
      lastName: {
        required: function () {
          return vueSupport?.featureFlags?.enableSignupRevamp ? 'ต้องระบุนามสกุล' : 'โปรดใส่นามสกุล'
        }
      },
      dob: {
        required: 'โปรดใส่วันเกิดของคุณ'
      },
      password: {
        required: 'โปรดใส่รหัส',
        min: 'รหัสต้องมีอย่างน้อย 8 ตัว'
      },
      postalCode: {
        required: 'กรุณาใส่รหัสไปรษณีย์ที่ถูกต้อง',
        min: function (_, min) {
          switch (I18n.siteCountryLs) {
            case 'au':
              return `โปรดใส่เลขรหัสไปรษณีย์จำนวน ${min} ตัว (เช่น 0200)`
            case 'nz':
              return `Please enter a valid postal code in ${min} digits (e.g. 02000)`
            case 'th':
              return `โปรดใส่เลขรหัสไปรษณีย์จำนวน ${min} ตัว`
            case 'my':
              return `โปรดใส่เลขรหัสไปรษณีย์จำนวน ${min} ตัว (เช่น 02000)`
            case 'ph':
              return `โปรดใส่เลขรหัสไปรษณีย์จำนวน ${min} ตัว (เช่น 0550)`
            case 'id':
              return `โปรดใส่เลขรหัสไปรษณีย์จำนวน ${min} ตัว`
            default:
              return `โปรดใส่เลขรหัสไปรษณีย์จำนวน ${min} ตัว`
          }
        },
        max: function (_, max) {
          switch (I18n.siteCountryLs) {
            case 'au':
              return `โปรดใส่เลขรหัสไปรษณีย์จำนวน ${max} ตัว (เช่น 0200)`
            case 'nz':
              return `Please enter a valid postal code in ${max} digits (e.g. 02000)`
            case 'th':
              return `โปรดใส่เลขรหัสไปรษณีย์จำนวน ${max} ตัว`
            case 'my':
              return `โปรดใส่เลขรหัสไปรษณีย์จำนวน ${max} ตัว (เช่น 02000)`
            case 'ph':
              return `โปรดใส่เลขรหัสไปรษณีย์จำนวน ${max} ตัว (เช่น 0550)`
            case 'id':
              return `โปรดใส่เลขรหัสไปรษณีย์จำนวน ${max} ตัว`
            default:
              return `โปรดใส่เลขรหัสไปรษณีย์จำนวน ${max} ตัว`
          }
        }
      },
      city: {
        required: 'โปรดเลือกเมืองที่ถูกต้อง'
      },
      state: {
        required: 'โปรดเลือกรัฐที่ถูกต้อง'
      },
      suburb: {
        required: 'โปรดเลือกชานเมืองที่ถูกต้อง'
      },
      addressOne: {
        required: 'กรุณาใส่ที่อยู่ที่ถูกต้อง',
        max: (_, max) => `โปรดตรวจสอบว่าที่อยู่ของคุณมีอักขระน้อยกว่า${max}ตัว`
      },
      district: {
        required: 'โปรดเลือกเขตที่ถูกต้อง'
      },
      province: {
        required: 'โปรดเลือกจังหวัดที่ถูกต้อง'
      },
      addressAndBarangay: {
        required: 'โปรดป้อนที่อยู่ที่ถูกต้อง & รังเกย์'
      },
      contactNumber: {
        required: 'กรุณาใส่หมายเลขติดต่อที่ถูกต้อง',
        numeric: 'โปรดตรวจสอบให้แน่ใจว่าได้ป้อนตัวเลขเท่านั้น',
        validatePhoneNumber: 'หมายเลขโทรศัพท์ของคุณไม่ถูกต้อง'
      },
      mobileNumber: {
        required: 'โปรดป้อนหมายเลขโทรศัพท์มือถือที่ถูกต้อง',
        numeric: 'โปรดตรวจสอบให้แน่ใจว่าได้ป้อนตัวเลขเท่านั้น',
        validatePhoneNumber: 'หมายเลขโทรศัพท์ของคุณไม่ถูกต้อง'
      },
      membershipId: {
        required: 'โปรดใส่หมายเลขสมาชิกของคุณ'
      },
      beautyPassNumber: {
        required:
          'กรุณาใส่หมายเลขสมาชิกบิวตี้พาสของคุณ เพื่อเชื่อมต่อระบบสมาชิกของเซโฟรากับบัญชีลาซาด้า'
      },
      distributionConsent: {
        required: 'โปรดยอมรับนโยบายส่วนบุคคลเพื่อไปต่อ'
      },
      nameOnCard: {
        required: 'กรุณาใส่ชื่อ.',
        nameOnCardValidator: 'โปรดป้อนชื่อบัตรเครดิตที่ถูกต้อง.'
      },
      cardNumber: {
        required: 'กรุณาใส่หมายเลขบัตร.',
        cardNumberValidator: 'โปรดป้อนหมายเลขบัตรเครดิตที่ถูกต้อง.',
        cardAvailability:
          'บัตรที่ใส่มาไม่สามารถใช้ได้ โปรดลองอีกครั้งด้วยบัตรอื่น'
      },
      expiration: {
        required: 'โปรดป้อนวันที่หมดอายุ.',
        expirationValidator: 'โปรดป้อนวันหมดอายุที่ถูกต้อง.'
      },
      cvc: {
        required: 'กรุณาใส่ cvc.',
        cvcValidator: 'โปรดป้อน cvc ที่ถูกต้อง.'
      },
      phoneNumberCode: {
        required: 'กรุณาเลือกรหัสประเทศ',
        phoneNumberValidator: 'โปรดเลือกรหัสประเทศที่ถูกต้อง'
      },
      phoneNumber: {
        required: 'กรุณาใส่หมายเลขโทรศัพท์',
        phoneNumberValidator: 'โปรดใส่เบอร์โทรศัพท์ที่ถูกต้อง'
      },
      selfCollectionSelection: {
        required: 'โปรดเลือกสถานที่ในการรับสินค้าด้วยตนเองเพื่อดำเนินการต่อ'
      },
      issuers: {
        required: 'โปรดเลือกวิธีชำระเงินที่ถูกต้อง'
      },
      name: {
        unicodesValidator: 'ไม่อนุญาตให้ใช้อิโมจิ'
      },
      title: {
        unicodesValidator: 'ไม่อนุญาตให้ใช้อิโมจิ'
      },
      text: {
        unicodesValidator: 'ไม่อนุญาตให้ใช้อิโมจิ'
      }
    }
  }
}
